const MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
let ready = false;

export function initAnalytics() {
  if (ready || !MEASUREMENT_ID || typeof window === "undefined") return;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", MEASUREMENT_ID, { send_page_view: false });

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
  document.head.appendChild(script);

  ready = true;
  pageView();
}

export function pageView(path = window.location.pathname + window.location.search) {
  if (!ready || !window.gtag) return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
}

export function event(name, params = {}) {
  if (!ready || !window.gtag) return;
  window.gtag("event", name, params);
}

export const analytics = {
  contactSubmitted: (method = "website_form") => event("generate_lead", { method }),
  whatsappClick: (location = "unknown") => event("whatsapp_click", { link_location: location }),
  ctaClick: (name, location = "unknown") => event("cta_click", { cta_name: name, link_location: location }),
};
